/**
 * The timecards list never sends its "Assignment name" keywords as a clause of their own: the case filter folds
 * their value into its own clause, matched on each of these selectors of the case's assignments. Kept apart from
 * the list's filter configuration so that whatever sends the list's filter from elsewhere reads the same rule
 * without loading the configuration.
 */
export const ASSIGNMENT_KEYWORDS_JOINT = {
    joinSelector: 'assignmentKeywords',
    selectors: ['matter.matterAssignments.name', 'matter.matterAssignments.description'],
};
